var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("aside", { attrs: { id: "result-card" } }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.isCurrentPlan
                ? _vm.$t("dash.plan.card.header.active")
                : _vm.$t("dash.plan.card.header.selection")
            ) +
            "\n    "
        ),
      ]),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "plan-header" }, [
          _c("h2", [
            _vm._v(
              _vm._s(
                _vm.result.plan.id === "custom"
                  ? _vm.$t("dash.plan.card.custom.name")
                  : _vm.result.plan.name
              )
            ),
          ]),
          _c("div", { staticClass: "offer-container" }, [
            _vm.result.savingsBadge
              ? _c("span", { staticClass: "savings-badge" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t(_vm.result.offerText)) +
                      "\n          "
                  ),
                ])
              : _vm._e(),
            _vm.result.offerText
              ? _c("span", { staticClass: "offer-text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t(_vm.result.savingsBadge, {
                          amount: _vm.result.savingsAmount,
                        })
                      ) +
                      "\n          "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm.result.plan.id !== "custom"
          ? _c("div", { staticClass: "price-display" }, [
              _c("span", { staticClass: "price" }, [
                _vm._v(_vm._s(_vm.formattedPrice) + "€ "),
                _c("sup", [_vm._v(_vm._s(_vm.$t("dash.plan.card.tax_label")))]),
              ]),
              _c("span", { staticClass: "period" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.result.priceLabel ? _vm.$t(_vm.result.priceLabel) : ""
                    )
                ),
              ]),
            ])
          : _c("div", { staticClass: "contact-display" }, [
              _c("span", { staticClass: "contact-text" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("dash.plan.card.custom.question")) +
                    "\n        "
                ),
              ]),
              _c("span", { staticClass: "contact-text" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("dash.plan.card.custom.answer")) +
                    "\n        "
                ),
              ]),
            ]),
        _vm.result.plan.id !== "custom"
          ? _c(
              "ul",
              { staticClass: "features-list" },
              [
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("dash.plan.card.features.up_to")) +
                      "\n          "
                  ),
                  _c("span", { staticClass: "feature-value" }, [
                    _vm._v(_vm._s(_vm.result.displayValues.socialAccounts)),
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("dash.plan.card.features.social_accounts")
                      ) +
                      "\n          "
                  ),
                  _vm.result.extraCosts.social
                    ? _c("span", { staticClass: "extra-cost-text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.result.extraCosts.social) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("dash.plan.card.features.up_to")) +
                      "\n          "
                  ),
                  _c("span", { staticClass: "feature-value" }, [
                    _vm._v(_vm._s(_vm.result.displayValues.users)),
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("dash.plan.card.features.users")) +
                      "\n          "
                  ),
                  _vm.result.extraCosts.users
                    ? _c("span", { staticClass: "extra-cost-text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.result.extraCosts.users) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("dash.plan.card.features.post_from")) +
                      "\n          "
                  ),
                  _c("span", { staticClass: "feature-value" }, [
                    _vm._v(_vm._s(_vm.result.displayValues.sources)),
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("dash.plan.card.features.sources")) +
                      "\n          "
                  ),
                  _vm.result.extraCosts.sources
                    ? _c("span", { staticClass: "extra-cost-text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.result.extraCosts.sources) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._l(_vm.featureKeys, function (featureKey, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      class: {
                        "not-included": !_vm.result.features[featureKey],
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t(_vm.featureLabels[featureKey])) +
                          "\n        "
                      ),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "cta-btn",
            class: {
              disabled: _vm.isCurrentPlan && _vm.result.plan.id !== "custom",
            },
            attrs: {
              disabled: _vm.isCurrentPlan && _vm.result.plan.id !== "custom",
            },
            on: { click: _vm.handleCTAClick },
          },
          [
            _vm.result.plan.id === "custom"
              ? [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("dash.plan.card.button.contact")) +
                      "\n        "
                  ),
                ]
              : _vm.isCurrentPlan
              ? [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("dash.plan.card.button.subscribed")) +
                      "\n        "
                  ),
                ]
              : [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("dash.plan.card.button.choose")) +
                      "\n        "
                  ),
                ],
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }